import { CareType } from '@uplift/api';

export const getCareTypeLabel = (careType?: CareType): string => {
  const labels: Record<string, string> = {
    [CareType.therapy]: 'Therapy',
    [CareType.psychiatry]: 'Psychiatry',
    [CareType.therapyAndPsychiatry]: 'Therapy and Psychiatry',
  };

  return labels[careType ?? ''] || 'Unknown Care Type';
};
